import { createSignal } from "solid-js";
export const [dead, setDead] = createSignal(false);
